import _toConsumableArray from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _extends from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/regenerator/index.js";
import * as React from 'react';
import { styled, useTheme } from '@mui/material/styles';
// Components
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';
import Collapse from '@mui/material/Collapse';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';
// Icons
import ThumbUpAltRoundedIcon from '@mui/icons-material/ThumbUpAltRounded';
import ThumbDownAltRoundedIcon from '@mui/icons-material/ThumbDownAltRounded';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import PanToolRoundedIcon from '@mui/icons-material/PanToolRounded';
import ArrowOutwardRoundedIcon from '@mui/icons-material/ArrowOutwardRounded';
import XIcon from '@mui/icons-material/X';
import YouTubeIcon from '@mui/icons-material/YouTube';
import RssFeedIcon from '@mui/icons-material/RssFeed';
import DiscordIcon from 'docs/src/icons/DiscordIcon';
// Other imports
import { Link } from '@mui/docs/Link';
import PageContext from 'docs/src/modules/components/PageContext';
import SvgMuiLogotype from 'docs/src/icons/SvgMuiLogotype';
import EditPage from 'docs/src/modules/components/EditPage';
import { useUserLanguage, useTranslate } from '@mui/docs/i18n';
import { pageToTitleI18n } from 'docs/src/modules/utils/helpers';
import useLocalStorageState from '@mui/utils/useLocalStorageState';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var FooterLink = styled(Link)(function (_ref) {
  var theme = _ref.theme;
  return _extends({
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.pxToRem(13),
    fontWeight: theme.typography.fontWeightMedium,
    color: (theme.vars || theme).palette.primary[600],
    '& > svg': {
      fontSize: '13px',
      transition: '0.2s'
    },
    '&:hover > svg': {
      transform: 'translateX(2px)'
    }
  }, theme.applyDarkStyles({
    color: (theme.vars || theme).palette.primary[300]
  }));
});

/**
 * @typedef {import('docs/src/pages').MuiPage} MuiPage
 * @typedef {import('docs/src/pages').OrderedMuiPage} OrderedMuiPage
 */

/**
 * This function is flattening the pages tree and extracts all the leaves that are internal pages.
 * To extract the leaves, it skips all the nodes that have at least one child.
 * @param {MuiPage[]} pages
 * @param {MuiPage[]} [current]
 * @returns {OrderedMuiPage[]}
 */
function orderedPages(pages) {
  var current = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return pages.reduce(function (items, item) {
    if (item.children && item.children.length > 0) {
      items = orderedPages(item.children, items);
    } else {
      items.push(item);
    }
    return items;
  }, current).filter(function (page) {
    return page.inSideNav !== false &&
    // ignore external pages
    page.pathname.startsWith('/');
  });
}
function submitFeedback(_x, _x2, _x3, _x4, _x5, _x6) {
  return _submitFeedback.apply(this, arguments);
}
/**
 * @returns { { prevPage: OrderedMuiPage | null; nextPage: OrderedMuiPage | null } }
 */
function _submitFeedback() {
  _submitFeedback = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(page, rating, comment, language, commentedSection, productId) {
    var sentData, res;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          sentData = {
            callback_id: 'send_feedback',
            rating: rating,
            comment: comment,
            currentLocationURL: window.location.href,
            commentSectionURL: "".concat(window.location.origin).concat(window.location.pathname, "#").concat(commentedSection.hash),
            commentSectionTitle: commentedSection.text,
            githubRepo: process.env.SOURCE_CODE_REPO,
            productId: productId
          };
          if (!(!comment || comment.length < 10)) {
            _context3.next = 3;
            break;
          }
          return _context3.abrupt("return", 'ignored');
        case 3:
          _context3.prev = 3;
          _context3.next = 6;
          return fetch("".concat(window.location.origin, "/.netlify/functions/feedback-management/"), {
            method: 'POST',
            headers: {
              'content-type': 'application/x-www-form-urlencoded'
            },
            // Seems tricky but it's to match how slack send data
            body: "payload=".concat(encodeURIComponent(JSON.stringify(sentData)))
          });
        case 6:
          res = _context3.sent;
          if (res.ok) {
            _context3.next = 9;
            break;
          }
          throw new Error("HTTP ".concat(res.status, ": ").concat(res.statusText));
        case 9:
          return _context3.abrupt("return", 'sent');
        case 12:
          _context3.prev = 12;
          _context3.t0 = _context3["catch"](3);
          console.error(_context3.t0);
          return _context3.abrupt("return", null);
        case 16:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[3, 12]]);
  }));
  return _submitFeedback.apply(this, arguments);
}
function usePageNeighbours() {
  var _pageList, _pageList2;
  var _React$useContext = React.useContext(PageContext),
    activePage = _React$useContext.activePage,
    pages = _React$useContext.pages;
  var pageList = orderedPages(pages);
  var currentPageNum = pageList.indexOf(activePage);
  if (currentPageNum === -1) {
    return {
      prevPage: null,
      nextPage: null
    };
  }
  var prevPage = (_pageList = pageList[currentPageNum - 1]) != null ? _pageList : null;
  var nextPage = (_pageList2 = pageList[currentPageNum + 1]) != null ? _pageList2 : null;
  return {
    prevPage: prevPage,
    nextPage: nextPage
  };
}
var EMPTY_SECTION = {
  hash: '',
  text: ''
};

// The design feedback alert was removed in https://github.com/mui/material-ui/pull/39691
// This dead code is here to simplify the creation of special feedback channel
var SPEACIAL_FEEDBACK_HASH = [{
  hash: 'new-docs-api-feedback',
  text: 'New API content design'
}];
var iconColor = 'grey.500';
export default function AppLayoutDocsFooter(props) {
  var _props$tableOfContent = props.tableOfContents,
    tableOfContents = _props$tableOfContent === void 0 ? [] : _props$tableOfContent,
    location = props.location;
  var theme = useTheme();
  var t = useTranslate();
  var userLanguage = useUserLanguage();
  var _React$useContext2 = React.useContext(PageContext),
    activePage = _React$useContext2.activePage,
    productId = _React$useContext2.productId;
  var _useLocalStorageState = useLocalStorageState("feedback-".concat(activePage == null ? void 0 : activePage.pathname)),
    _useLocalStorageState2 = _slicedToArray(_useLocalStorageState, 2),
    storedRating = _useLocalStorageState2[0],
    setRating = _useLocalStorageState2[1];
  var _React$useState = React.useState(''),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    comment = _React$useState2[0],
    setComment = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    loading = _React$useState4[0],
    setLoading = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    snackbarOpen = _React$useState6[0],
    setSnackbarOpen = _React$useState6[1];
  var _React$useState7 = React.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    snackbarMessage = _React$useState8[0],
    setSnackbarMessage = _React$useState8[1];
  var inputRef = React.useRef();
  var _React$useState9 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    commentOpen = _React$useState10[0],
    setCommentOpen = _React$useState10[1];
  var _React$useState11 = React.useState(EMPTY_SECTION),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    commentedSection = _React$useState12[0],
    setCommentedSection = _React$useState12[1];
  var rating = storedRating ? Number(storedRating) : null;
  var _usePageNeighbours = usePageNeighbours(),
    nextPage = _usePageNeighbours.nextPage,
    prevPage = _usePageNeighbours.prevPage;
  var sectionOptions = React.useMemo(function () {
    return tableOfContents.flatMap(function (section) {
      return [{
        hash: section.hash,
        text: section.text
      }].concat(_toConsumableArray(section.children.map(function (_ref2) {
        var hash = _ref2.hash,
          text = _ref2.text;
        return {
          hash: hash,
          text: text
        };
      })));
    });
  }, [tableOfContents]);
  function processFeedback() {
    return _processFeedback.apply(this, arguments);
  }
  function _processFeedback() {
    _processFeedback = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var result;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            setLoading(true);
            if (activePage === null) {
              setSnackbarMessage(t('feedbackFailed'));
            }
            _context2.next = 5;
            return submitFeedback(activePage.pathname, rating, comment, userLanguage, commentedSection, productId);
          case 5:
            result = _context2.sent;
            if (result) {
              setSnackbarMessage(t('feedbackSubmitted'));
            } else {
              setSnackbarMessage(t('feedbackFailed'));
            }
            setSnackbarOpen(true);
          case 8:
            _context2.prev = 8;
            setLoading(false);
            return _context2.finish(8);
          case 11:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0,, 8, 11]]);
    }));
    return _processFeedback.apply(this, arguments);
  }
  var handleClickThumb = function handleClickThumb(vote) {
    return /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (vote !== rating) {
              setRating(vote);
              setCommentOpen(true);
            }

            // Manually move focus if comment is already open.
            // If the comment is closed, onEntered will call focus itself;
            if (inputRef.current) {
              inputRef.current.focus();
            }
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
  };
  var handleChangeTextfield = function handleChangeTextfield(event) {
    setComment(event.target.value);
  };
  var handleSubmitComment = function handleSubmitComment(event) {
    event.preventDefault();
    // Block more than one submission.
    // Technically, setState() is async in React, so a ninja user could still
    // manage to trigger a double form submission. Still, let's wait and see
    // before adding the overhead of a React ref to solve this.
    if (!commentOpen) {
      return;
    }
    setCommentOpen(false);
    processFeedback();
  };

  // See https://github.com/mui/toolpad/issues/1164 for context.
  var handleKeyDownForm = function handleKeyDownForm(event) {
    var modifierKey = (event.metaKey || event.ctrlKey) && !event.shiftKey;
    if (event.key === 'Enter' && modifierKey) {
      var submitButton = event.currentTarget.querySelector('[type="submit"]');
      submitButton.click();
    }
  };
  var handleCancelComment = function handleCancelComment() {
    setCommentOpen(false);
    setCommentedSection(EMPTY_SECTION);
  };
  var handleEntered = function handleEntered() {
    inputRef.current.focus();
  };
  var handleCloseSnackbar = function handleCloseSnackbar() {
    setSnackbarOpen(false);
  };
  React.useEffect(function () {
    var eventListener = function eventListener(event) {
      var feedbackHash = event.target.getAttribute('data-feedback-hash');
      if (feedbackHash) {
        var section = [].concat(_toConsumableArray(sectionOptions), SPEACIAL_FEEDBACK_HASH).find(function (item) {
          return item.hash === feedbackHash;
        }) || EMPTY_SECTION;
        setCommentOpen(true);
        setCommentedSection(section);

        // Manually move focus if comment is already open.
        // If the comment is closed, onEntered will call focus itself;
        if (inputRef.current) {
          inputRef.current.focus();
        }
      }
    };
    document.addEventListener('click', eventListener);
    return function () {
      document.removeEventListener('click', eventListener);
    };
  }, [sectionOptions]);
  var hidePagePagination = activePage === null || activePage.ordered === false;
  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [/*#__PURE__*/_jsxs(Stack, {
      component: "footer",
      direction: "column",
      sx: {
        my: 4
      },
      children: [/*#__PURE__*/_jsxs(Stack, {
        direction: {
          xs: 'column',
          sm: 'row'
        },
        spacing: {
          xs: 3,
          sm: 1
        },
        sx: {
          alignItems: 'center',
          justifyContent: 'space-between'
        },
        children: [/*#__PURE__*/_jsx(EditPage, {
          sourceLocation: location
        }), /*#__PURE__*/_jsxs(Stack, {
          direction: "row",
          spacing: 0.5,
          useFlexGap: true,
          sx: {
            alignItems: 'center'
          },
          children: [/*#__PURE__*/_jsx(Typography, {
            id: "feedback-message",
            variant: "body2",
            sx: {
              color: 'text.secondary'
            },
            children: t('feedbackMessage')
          }), /*#__PURE__*/_jsx(Tooltip, {
            title: t('feedbackYes'),
            children: /*#__PURE__*/_jsx(IconButton, {
              onClick: handleClickThumb(1),
              disabled: loading,
              "aria-pressed": rating === 1,
              sx: {
                fontSize: 15,
                color: rating === 1 ? 'primary.main' : 'text.secondary'
              },
              children: rating === 1 && loading ? /*#__PURE__*/_jsx(CircularProgress, {
                size: 15
              }) : /*#__PURE__*/_jsx(ThumbUpAltRoundedIcon, {
                fontSize: "inherit"
              })
            })
          }), /*#__PURE__*/_jsx(Tooltip, {
            title: t('feedbackNo'),
            children: /*#__PURE__*/_jsx(IconButton, {
              onClick: handleClickThumb(0),
              disabled: loading,
              "aria-pressed": rating === 0,
              sx: {
                fontSize: 15,
                color: rating === 0 ? 'error.main' : 'text.secondary'
              },
              children: rating === 0 && loading ? /*#__PURE__*/_jsx(CircularProgress, {
                size: 15
              }) : /*#__PURE__*/_jsx(ThumbDownAltRoundedIcon, {
                fontSize: "inherit"
              })
            })
          })]
        })]
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsxs(Collapse, {
          "in": commentOpen,
          unmountOnExit: true,
          onEntered: handleEntered,
          timeout: {
            enter: 0,
            exit: theme.transitions.duration.standard
          },
          children: [/*#__PURE__*/_jsx(Divider, {
            sx: {
              my: 2,
              borderStyle: 'dashed'
            }
          }), /*#__PURE__*/_jsx("form", {
            "aria-labelledby": "feedback-message",
            onReset: handleCancelComment,
            onSubmit: handleSubmitComment,
            onKeyDown: handleKeyDownForm,
            children: /*#__PURE__*/_jsxs("div", {
              children: [commentedSection.text ? /*#__PURE__*/_jsx(Typography, {
                variant: "body2",
                id: "feedback-description",
                dangerouslySetInnerHTML: {
                  __html: t('feedbackSectionSpecific').replace('{{sectionName}}', "\"".concat(commentedSection.text, "\""))
                },
                sx: {
                  color: 'text.secondary'
                }
              }) : /*#__PURE__*/_jsx(Typography, {
                id: "feedback-description",
                sx: {
                  color: 'text.secondary'
                },
                children: rating === 1 ? t('feedbackMessageUp') : t('feedbackMessageDown')
              }), /*#__PURE__*/_jsx(TextField, {
                multiline: true,
                margin: "dense",
                name: "comment",
                fullWidth: true,
                rows: 2,
                value: comment,
                onChange: handleChangeTextfield,
                inputProps: {
                  'aria-label': t('feedbackCommentLabel'),
                  'aria-describedby': 'feedback-description',
                  ref: inputRef
                }
              }), rating !== 1 && true && /*#__PURE__*/_jsx(Alert, {
                severity: "warning",
                color: "warning",
                icon: /*#__PURE__*/_jsx(PanToolRoundedIcon, {
                  fontSize: "small"
                }),
                sx: {
                  my: 1.5
                },
                children: /*#__PURE__*/_jsxs(Typography, {
                  id: "feedback-description",
                  children: [t('feedbackMessageToGitHub.usecases'), ' ', /*#__PURE__*/_jsx(Link, {
                    href: "".concat(process.env.SOURCE_CODE_REPO, "/issues/new?template=").concat(process.env.GITHUB_TEMPLATE_DOCS_FEEDBACK, "&page-url=").concat(window.location.href),
                    target: "_blank",
                    underline: "always",
                    sx: {
                      fontWeight: 'semiBold'
                    },
                    children: t('feedbackMessageToGitHub.callToAction.link')
                  }), ' ', t('feedbackMessageToGitHub.reasonWhy')]
                })
              }), /*#__PURE__*/_jsxs(DialogActions, {
                children: [/*#__PURE__*/_jsx(Button, {
                  type: "reset",
                  size: "small",
                  children: t('cancel')
                }), /*#__PURE__*/_jsx(Button, {
                  type: "submit",
                  variant: "contained",
                  size: "small",
                  children: t('submit')
                })]
              })]
            })
          })]
        })
      }), /*#__PURE__*/_jsx(Divider, {
        sx: {
          my: 2
        }
      }), hidePagePagination ? null : /*#__PURE__*/_jsxs(Stack, {
        direction: "row",
        sx: {
          justifyContent: 'space-between'
        },
        children: [prevPage !== null ? /*#__PURE__*/_jsx(Button, _extends({
          size: "small",
          variant: "text",
          component: Link,
          noLinkStyle: true,
          prefetch: false,
          href: prevPage.pathname
        }, prevPage.linkProps, {
          startIcon: /*#__PURE__*/_jsx(ChevronLeftIcon, {}),
          children: pageToTitleI18n(prevPage, t)
        })) : /*#__PURE__*/_jsx("div", {}), nextPage !== null ? /*#__PURE__*/_jsx(Button, _extends({
          size: "small",
          component: Link,
          noLinkStyle: true,
          prefetch: false,
          href: nextPage.pathname
        }, nextPage.linkProps, {
          endIcon: /*#__PURE__*/_jsx(ChevronRightIcon, {}),
          children: pageToTitleI18n(nextPage, t)
        })) : null]
      }), /*#__PURE__*/_jsx(Divider, {
        sx: {
          my: 2
        }
      }), /*#__PURE__*/_jsxs(Stack, {
        direction: {
          xs: 'column',
          sm: 'row'
        },
        spacing: {
          xs: 3,
          sm: 1
        },
        sx: {
          alignItems: 'center'
        },
        children: [/*#__PURE__*/_jsxs(Stack, {
          direction: "row",
          spacing: 1,
          useFlexGap: true,
          sx: {
            alignItems: 'center',
            flexGrow: 1
          },
          children: [/*#__PURE__*/_jsx(Link, {
            href: "https://mui.com/",
            "aria-label": "Go to homepage",
            children: /*#__PURE__*/_jsx(SvgMuiLogotype, {
              height: 28,
              width: 64
            })
          }), /*#__PURE__*/_jsx(Typography, {
            sx: {
              color: 'grey.500',
              fontSize: 13,
              opacity: '70%'
            },
            children: "\u2022"
          }), /*#__PURE__*/_jsxs(FooterLink, {
            href: "https://mui.com/blog/",
            target: "_blank",
            rel: "noopener",
            children: ["Blog ", /*#__PURE__*/_jsx(ArrowOutwardRoundedIcon, {})]
          }), /*#__PURE__*/_jsx(Typography, {
            sx: {
              color: 'grey.500',
              fontSize: 13,
              opacity: '70%'
            },
            children: "\u2022"
          }), /*#__PURE__*/_jsxs(FooterLink, {
            href: "https://mui.com/store/",
            target: "_blank",
            rel: "noopener",
            children: ["Store ", /*#__PURE__*/_jsx(ArrowOutwardRoundedIcon, {})]
          })]
        }), /*#__PURE__*/_jsxs(Stack, {
          spacing: 1,
          direction: "row",
          useFlexGap: true,
          children: [/*#__PURE__*/_jsx(IconButton, {
            target: "_blank",
            rel: "noopener",
            href: "https://x.com/MUI_hq",
            "aria-label": "X/twitter",
            title: "X",
            size: "small",
            children: /*#__PURE__*/_jsx(XIcon, {
              fontSize: "small",
              sx: {
                color: iconColor
              }
            })
          }), /*#__PURE__*/_jsx(IconButton, {
            target: "_blank",
            rel: "noopener",
            href: "https://mui.com/r/discord/",
            "aria-label": "Discord",
            title: "Discord",
            size: "small",
            children: /*#__PURE__*/_jsx(DiscordIcon, {
              fontSize: "small",
              sx: {
                color: iconColor
              }
            })
          }), /*#__PURE__*/_jsx(IconButton, {
            target: "_blank",
            rel: "noopener",
            href: "https://www.youtube.com/@MUI_hq",
            "aria-label": "YouTube",
            title: "YouTube",
            size: "small",
            children: /*#__PURE__*/_jsx(YouTubeIcon, {
              fontSize: "small",
              sx: {
                color: iconColor
              }
            })
          }), /*#__PURE__*/_jsx(IconButton, {
            target: "_blank",
            rel: "noopener",
            href: "https://mui.com/feed/blog/rss.xml",
            "aria-label": "RSS Feed",
            title: "RSS Feed",
            size: "small",
            children: /*#__PURE__*/_jsx(RssFeedIcon, {
              fontSize: "small",
              sx: {
                color: iconColor
              }
            })
          })]
        })]
      })]
    }), /*#__PURE__*/_jsx(Snackbar, {
      open: snackbarOpen,
      autoHideDuration: 3000,
      onClose: handleCloseSnackbar,
      message: snackbarMessage
    })]
  });
}
false ? void 0 : void 0;